import type { FC } from "react"
import { twMerge } from "tailwind-merge"

import type { Company, Location } from "@/graphql/codegen/graphql"
import { formatLocationAddress } from "@/utils/utils"

interface WarehouseLocationInfoProps {
  company: Company
  location: Location
  externalSystemId: string
  className?: string
}

const WarehouseLocationInfo: FC<WarehouseLocationInfoProps> = ({
  company,
  location,
  externalSystemId,
  className = "",
}) => {
  return (
    <div data-testid='warehouse-location-preview' className={twMerge("flex justify-center text-left", className)}>
      <dl className='grid grid-cols-[auto_1fr] gap-x-4 p-2 text-sm/[1.25] tracking-[0.17px] text-gray-700'>
        <dt className='font-bold'>Company</dt>
        <dd data-testid='warehouse-location-preview-company'>{company.name}</dd>
        <dt className='font-bold'>Address</dt>
        <dd data-testid='warehouse-location-preview-address'>{formatLocationAddress(location)}</dd>
        <dt className='font-bold'>AS400 ID</dt>
        <dd data-testid='warehouse-location-preview-address'>{externalSystemId}</dd>
      </dl>
    </div>
  )
}

export default WarehouseLocationInfo
